import { render } from "./PublicMenuView.vue?vue&type=template&id=87756fb2&scoped=true"
import script from "./PublicMenuView.vue?vue&type=script&lang=js"
export * from "./PublicMenuView.vue?vue&type=script&lang=js"

import "./PublicMenuView.vue?vue&type=style&index=0&id=87756fb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87756fb2"]])

export default __exports__